import React from 'react';
import { StyleSheet, View, Platform, ScrollView } from 'react-native';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Heading from 'src/presentation/components/atoms/Heading';
import FeedbackForm from 'src/presentation/components/organisms/forms/FeedbackForm';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';

function FeedbackScreen() {
	return (
		<View style={{ flex: 1 }}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={Translations.titleFeedback}
			/>
			<ScrollView contentContainerStyle={styles.scrollContent} style={styles.scroll}>
				<View style={styles.contentContainer}>
					<Heading text={Translations.titleFeedback} />
				</View>
				<FeedbackForm />
			</ScrollView>
		</View>
	);
}

export default FeedbackScreen;

const styles = StyleSheet.create({
	scroll: {
		backgroundColor: Colors.white,
	},
	scrollContent: {
		flexGrow: 1,
		justifyContent: 'center',
		backgroundColor: Colors.white,
	},
	contentContainer: {
		paddingLeft: Dimens.padding20,
		paddingTop: Dimens.padding20,
		marginBottom: Platform.OS === 'android' ? Dimens.margin5 : Dimens.margin30,
	},
});
